// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"7bf0407e","174":"8deafd70","376":"0ec1318f","400":"ae4b24fa","506":"085ed459","540":"9fa65c0a","953":"dcaad8b6","962":"562173e8","980":"30e1db13"}[chunkId] + ".chunk.js";
};